import {
  connectAuthEmulator,
  type Auth,
} from 'firebase/auth'
import { resolveFirebaseAuthEmulatorUrl } from './firebaseAuthEmulatorConfig'

type EmulatorConnector = (
  auth: Auth,
  url: string,
  options: { disableWarnings: boolean },
) => void

export function connectFirebaseAuthEmulatorIfConfigured(
  auth: Auth,
  value: unknown,
  connector: EmulatorConnector = connectAuthEmulator,
): boolean {
  const url = resolveFirebaseAuthEmulatorUrl(value)
  if (!url) return false
  connector(auth, url, { disableWarnings: true })
  return true
}
